import React from 'react';
import classnames from 'classnames';
import debounce from 'lodash/debounce'
import objectFitVideos from 'object-fit-videos';

import vid_1860_1870 from '../mov/train-190226/1860_1870.mp4';
import vid_1870_1880 from '../mov/train-190226/1870_1880.mp4';
import vid_1890_1900 from '../mov/train-190226/1890_1900.mp4';
import vid_1900_1910 from '../mov/train-190226/1900_1910.mp4';
import vid_1910_1920 from '../mov/train-190226/1910_1920.mp4';
import vid_1920_1930 from '../mov/train-190226/1920_1930.mp4';
import vid_1930_1940 from '../mov/train-190226/1930_1940.mp4';
import vid_1940_1950 from '../mov/train-190226/1940_1950.mp4';
import vid_1950_1960 from '../mov/train-190226/1950_1960.mp4';
import vid_1960_1970 from '../mov/train-190226/1960_1970.mp4';
import vid_1970_1980 from '../mov/train-190226/1970_1980.mp4';
import vid_1980_1990 from '../mov/train-190226/1980_1990.mp4';
import vid_1990_2000 from '../mov/train-190226/1990_2000.mp4';
import vid_2000_2010 from '../mov/train-190226/2000_2010.mp4';

import img_2020 from '../images/last_intro_frames/2010_2020.jpg';

export default class TimelineVideo extends React.PureComponent {
  state = {
    videoSrc: '',
    videoRef: React.createRef(),
    playing: false,
    currentTime: 0
  }

  _onPlaying = () => {
    this.setState({ playing: true });
    this.props.onPlaying(true);
  }
  _onAbort = () => {
    this.setState({ playing: false })
    this.props.onPlaying(false);
  }
  _onLoaded = debounce(() => {
    const v = this.state.videoRef.current;
    if (v) v.currentTime = this.state.currentTime;
  }, 25);

  componentDidMount() {
    const v = this.state.videoRef.current;

    v.addEventListener('playing', this._onPlaying);
    v.addEventListener('abort', this._onAbort);

    v.addEventListener('loadedmetadata', this._onLoaded);

    // Safari
    v.addEventListener('loadeddata', this._onLoaded);

    objectFitVideos(v);
  }

  componentWillUnmount() {
    const v = this.state.videoRef.current;

    v.removeEventListener('playing', this._onPlaying);
    v.removeEventListener('abort', this._onAbort);

    v.removeEventListener('loadedmetadata', this._onLoaded);

    // Safari
    v.removeEventListener('loadeddata', this._onLoaded);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.year !== this.props.year) {
      this.replaceVideoSrc();
    }
  }

  get getVideoSrc() {
    switch (this.props.year) {
      case "1860":
        return '';
      case "1871":
      case "1880":
        return vid_1860_1870;
      case "1890":
        return vid_1870_1880;
      case "1900":
        return vid_1890_1900;
      case "1910":
        return vid_1900_1910;
      case "1920":
        return vid_1910_1920;
      case "1930":
        return vid_1920_1930;
      case "1940":
        return vid_1930_1940;
      case "1950":
        return vid_1940_1950;
      case "1960":
        return vid_1950_1960;
      case "1970":
        return vid_1960_1970;
      case "1980":
        return vid_1970_1980;
      case "1990":
        return vid_1980_1990;
      case "2000":
        return vid_1990_2000;
      case "2010":
        return vid_2000_2010;
      default:
        return false;
    }
  }

  _replaceVideoSrc = () => {
    const v = this.state.videoRef.current;
    const videoSrc = this.getVideoSrc;

    if (v && videoSrc !== this.state.videoSrc) {
      v.pause();

      this.setState({
        videoSrc,
        currentTime: v.currentTime,
        playing: false
      }, () => {
        if (videoSrc) {
          v.src = videoSrc;
        } else {
          // No video src, no reason to wait for 'playing' event
          this.props.onPlaying(true);
        }
      });
    }
  }
  replaceVideoSrc = debounce(this._replaceVideoSrc, 100);

  get sourceClass() {
    return classnames("hero opacity-animated", {
      "opacity-0": this.props.hide || !this.state.playing,
    });
  }

  render() {
    // We need a wrapping div here to prevent the object-fit-videos polyfill from crashing on ie
    return (
      <div>
        <video
          className="hero"
          ref={this.state.videoRef}
          id="v1" tabIndex="0" playsInline autobuffer="autobuffer" preload="preload" loop="loop" autoPlay="autoplay" muted
        >
          {this.state.videoSrc && (
            <source type="video/mp4" src={this.state.videoSrc} className={this.sourceClass} />
          )}
        </video>
        {this.props.year === '2020' && (
          <img className="hero" src={img_2020} />
        )}
      </div>
    );
  }
}